import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "alertFilter" })
export class AlertFilter implements PipeTransform {
  transform(
    array: any[],
    active: boolean,
    projectFilter: string,
    nationalityFilter: string,
    employerFilter: string,
    countryFilter: string
  ): any[] {
    if (array) {
      return array.filter((alert) => {
        let result = true;
        result = !active || alert.active || false;
        if (result) {
          if (projectFilter && projectFilter !== "undefined") {
            result =
              alert.context.project_ids.filter((id) => {
                return id === projectFilter;
              }).length > 0;
          }
          if (result) {
            if (nationalityFilter && nationalityFilter !== "undefined") {
              result =
                alert.context.nationalities.filter((id) => {
                  return id === nationalityFilter;
                }).length > 0;
            }
            if (result) {
              if (employerFilter && employerFilter !== "undefined") {
                result =
                  alert.context.employer_ids.filter((id) => {
                    return id === employerFilter;
                  }).length > 0;
              }
              if (result) {
                if (
                  countryFilter &&
                  countryFilter !== "undefined" &&
                  alert.context.countries
                ) {
                  result =
                    alert.context.countries.filter((id) => {
                      return id === countryFilter;
                    }).length > 0;
                }
              }
            }
          }
        }
        return result;
      });
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/alerts/alerts.filter.ts